import React from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "src/components/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import type { ClientErrorRecord } from "src/interfaces/errorStats.interface";

const useStyles = makeStyles((theme) => ({
  field: {
    marginTop: theme.spacing(1),
    wordBreak: "break-word",
  },
  mono: {
    fontFamily: "monospace",
    fontSize: "0.85rem",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
}));

interface ErrorDetailsDialogProps {
  error: ClientErrorRecord | null;
  open: boolean;
  onClose: () => void;
  onExited?: () => void;
}

function ErrorDetailsDialog({
  error,
  open,
  onClose,
  onExited,
}: ErrorDetailsDialogProps) {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      TransitionProps={{ onExited }}
    >
      <DialogTitle>Error details</DialogTitle>
      <DialogContent>
        {error ? (
          <>
            <Typography variant="body2" className={classes.field}>
              <strong>Message:</strong> {error.message}
            </Typography>
            {error.name ? (
              <Typography variant="body2" className={classes.field}>
                <strong>Name:</strong> {error.name}
              </Typography>
            ) : null}
            <Typography variant="body2" className={classes.field}>
              <strong>Source:</strong> {error.source}
            </Typography>
            {error.accountant ? (
              <Typography variant="body2" className={classes.field}>
                <strong>Accountant:</strong>{" "}
                {error.accountantUsername || error.accountant}
              </Typography>
            ) : null}
            {error.url ? (
              <Typography variant="body2" className={classes.field}>
                <strong>URL:</strong> {error.url}
              </Typography>
            ) : null}
            {error.userAgent ? (
              <Typography variant="body2" className={classes.field}>
                <strong>User agent:</strong> {error.userAgent}
              </Typography>
            ) : null}
            {error.stack ? (
              <>
                <Typography variant="body2" className={classes.field}>
                  <strong>Stack:</strong>
                </Typography>
                <Typography
                  component="pre"
                  variant="body2"
                  className={classes.mono}
                >
                  {error.stack}
                </Typography>
              </>
            ) : null}
            {error.componentStack ? (
              <>
                <Typography variant="body2" className={classes.field}>
                  <strong>Component stack:</strong>
                </Typography>
                <Typography
                  component="pre"
                  variant="body2"
                  className={classes.mono}
                >
                  {error.componentStack}
                </Typography>
              </>
            ) : null}
          </>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ErrorDetailsDialog;
